import { render } from "./CompanyJobAd.vue?vue&type=template&id=707f5554&ts=true"
import script from "./CompanyJobAd.vue?vue&type=script&lang=ts"
export * from "./CompanyJobAd.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__